module.exports = __webpack_public_path__ + "img/icon-send-money-now.8684ee0d.svg";